<template>
    <div class="modals" v-show="showLoading">
        <Spinner class="spinner" :message="loadingMsg" textFgColor="#ffffff"></Spinner>
    </div>
</template>

<script type="text/ecmascript-6">
  import Spinner from 'vue-simple-spinner'

  export default {
    props: {
      showLoading: {
        default: false,
        type: Boolean
      },
      loadingMsg: {
        default: '',
        type: String
      }
    },
    data () {
      return {}
    },
    components: {Spinner},

  }
</script>
<style lang="scss" scoped type="text/css">
    @import "loading.scss";
</style>
